/* eslint-disable no-undef */
import { config } from '../../constants/config';
import { parseWebSocketMessage } from '../../helpers/pusher';

interface IPusherMessage {
    type: string;
    data?: any;
}

class PusherService {
    private messageListeners: Record<string, Function> = {};

    private openListeners: Function[] = [];

    private ws: WebSocket | undefined;

    private keepaliveInterval: NodeJS.Timeout | undefined = undefined;

    close = () => {
        this.ws?.close();
        this.messageListeners = {};
        this.openListeners = [];
        if (this.keepaliveInterval) {
            clearInterval(this.keepaliveInterval);
        }
    };

    open = (channel: string) => {
        this.ws = new WebSocket(config.socketUrl, channel);
        this.ws.addEventListener('message', this.onMessage);
        this.ws.addEventListener('open', this.onOpen);
    };

    registerMessageListener = (type: string, func: Function) => {
        this.messageListeners[type] = func;
    };

    registerOpenListener = (func: Function) => {
        this.openListeners.push(func);
    };

    private onMessage = (message: MessageEvent) => {
        if (message.data) {
            const t = parseWebSocketMessage<IPusherMessage>(message.data);
            if (t && typeof this.messageListeners[t.type] === 'function') {
                this.messageListeners[t.type](t.data);
            }
        }
    };

    private onOpen = () => {
        this.openListeners.forEach((func) => {
            func();
        });
        this.keepaliveInterval = setInterval(() => {
            this.ws?.send('keepalive');
        }, 10000);
    };
}

export default PusherService;
